import { Box, styled } from '@mui/material';
import { motion } from 'motion/react';
import { useAtomValue } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback, useEffect } from 'react';
import { activeCompanyListIdStateJ, companyListStateJ } from '../../../services/state/ListsStateJ';
import { borderStyle } from '../../../theme/component-styles';
import { MaggieFeatureFlags } from '../../../util/feature-flags';
import { filteredAndSortedListsStateJ } from '../Companies/state/FiltersStateJ';
import { CompanyListContainerBreakpoints, ContainerName } from '../../../constants/styles';
import { NoDataMessage2 } from '../components/Messages/HelpMessage';
import { MemoizedListCard } from './ListCard';
import { ListItemDetailsPanel } from './ListItemDetailsPanel';
import { ListItemDetailsPanel as ListItemDetailsPanel2 } from './ListItemDetailsPanel2';

const CompanyListContainer = styled('div')`
  display: grid;
  grid-column-gap: 0.5rem;
  grid-template-columns: 300px 1fr;
  @container ${ContainerName.companyLists} (max-width: ${CompanyListContainerBreakpoints.medium}px) {
    grid-template-columns: 200px 1fr;
  }
  width: 100%;
  overflow: hidden;
`;

const RightSection = styled('div')`
  ${borderStyle};
  background: white;
  display: grid;
  align-items: start;
  grid-row-gap: 0.5rem;
  overflow: auto;
`;

// TODO maybe returns selctedIndex to here
export function CompanyList2({
  setSelectedIndex,
  selectedIndex,
}: {
  setSelectedIndex: (index: number) => void;
  selectedIndex: number;
}) {
  const activeListId = useAtomValue(activeCompanyListIdStateJ);
  const listItems = useAtomValue(companyListStateJ(activeListId))?.items;
  const sortedList = useAtomValue(filteredAndSortedListsStateJ(activeListId ?? -1));
  const { showListDetailsAsPanel } = useFlags<MaggieFeatureFlags>();

  useEffect(() => {
    setSelectedIndex(0);
  }, [setSelectedIndex, sortedList?.length]);

  const handleListItemClick = useCallback(
    (newIndex: number) => {
      setSelectedIndex(newIndex);
    },
    [setSelectedIndex]
  );

  const gotoNext = useCallback(() => {
    // const nextIndex = (selectedIndex + 1) % (sortedList?.length ?? 0);
    // setSelectedIndex(nextIndex);
    // Do nothing for now
  }, []);

  if (!listItems?.length) {
    return <NoDataMessage2 message='The list is empty.' />;
  }

  if (!sortedList || !sortedList[selectedIndex]) {
    return null;
  }

  return (
    <CompanyListContainer>
      <Box sx={{ overflow: 'auto', background: 'transparent', padding: 0 }}>
        {sortedList.map((item, i) => {
          return (
            <motion.div key={item.id} layout transition={{ duration: 0.5 }}>
              <MemoizedListCard
                selected={selectedIndex === i}
                item={item}
                onClick={() => handleListItemClick(i)}
              />
            </motion.div>
          );
        })}
      </Box>
      <RightSection>
        {showListDetailsAsPanel ? (
          <ListItemDetailsPanel2 gotoNext={gotoNext} item={sortedList[selectedIndex]} />
        ) : (
          <ListItemDetailsPanel gotoNext={gotoNext} item={sortedList[selectedIndex]} />
        )}
      </RightSection>
    </CompanyListContainer>
  );
}
